export default "__VITE_ASSET__Da$savKs__"